import { useLocation } from "react-router-dom";
import { LocalizedNavLink as NavLink } from "./LocalizedLink";
import clsx from "clsx";
import { isSectionPathActive } from "../lib/sectionNavigation";

export default function NavItem({ to, icon: Icon, label, onClick, isActive: isActiveProp }) {
  const location = useLocation();
  const isActive =
    typeof isActiveProp === "boolean"
      ? isActiveProp
      : isSectionPathActive(location.pathname, to);

  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={clsx("nav-item", isActive && "is-active")}
    >
      {Icon && <Icon className="w-5 h-5" />}
      <span>{label}</span>
    </NavLink>
  );
}
